import React from 'react';
import styled from 'styled-components/macro';
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
import AttachFileIcon from '@material-ui/icons/AttachFile';

const RowContainer = styled.div`
  display: flex;
  gap: 1rem;
`;

const DotContainer = styled.div`
  color: #4c84ff;
  font-size: 24px;
  line-height: 0.7;
  position: relative;
`;

const ConnectingLine = styled.div`
  position: absolute;
  width: 0px;
  border-left: 1px solid #a6c4fdbf;
  top: 22px;
  bottom: 5px;
  left: 7px;
`;

const ContentContainer = styled.div`
  flex: 1;
  padding-bottom: 1rem;
`;

const DateRow = styled.div``;

const ChatBubble = styled(ChatBubbleOutlineIcon)`
  && {
    width: 16px;
  }
`;

const PaperClip = styled(AttachFileIcon)`
  && {
    transform: rotate(45deg);
    width: 16px;
  }
`;

const TaskActivityView = props => {
  const activityCount = props.activityData.length;
  return (
    <div>
      {props.activityData.map((one, i) => {
        return (
          <RowContainer>
            <DotContainer>
              {one.event === 'comment' ? (
                <ChatBubble />
              ) : one.event === 'file_uploaded' ||
                one.event === 'file_removed' ? (
                <PaperClip />
              ) : (
                '●'
              )}
              {i !== activityCount - 1 ? <ConnectingLine /> : ''}
            </DotContainer>
            <ContentContainer>
              <DateRow>{one.formattedDate}</DateRow>
              {one.activityRow}
            </ContentContainer>
          </RowContainer>
        );
      })}
    </div>
  );
};

export default TaskActivityView;
